"use client";

import type { BasketballTemplateData } from "../basketball-template";
import { ActivityCourtPreview } from "./activity-court-preview";

type BasketballDisplayPreviewProps = {
  data: BasketballTemplateData | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function BasketballDisplayPreview({
  data,
  participants,
}: BasketballDisplayPreviewProps) {
  if (!data) {
    return (
      <ActivityCourtPreview
        activityId="basketball"
        yourTeam={[]}
        opponentTeam={[]}
      />
    );
  }

  const yourTeam = participants
    .filter((p) => data.positions[p.id] === "your-team")
    .map((p) => ({ ...p, handle: p.username ?? undefined }));
  const opponentTeam = participants
    .filter((p) => data.positions[p.id] === "opponent-team")
    .map((p) => ({ ...p, handle: p.username ?? undefined }));

  const showScore = data.hasScore !== false;
  const yourWon = data.matchScore.yourPoints > data.matchScore.opponentPoints;

  return (
    <div>
      <ActivityCourtPreview
        activityId="basketball"
        data={data}
        yourTeam={yourTeam}
        opponentTeam={opponentTeam}
        yourWon={showScore ? yourWon : undefined}
        linkToProfiles
      />
    </div>
  );
}
